import React from "react";

import { Grid, Row } from "rsuite";

export const ItemsWrap = ({ children }) => (
  <Grid className="items-wrap">
    <Row className="">{children}</Row>
  </Grid>
);
